import { render, staticRenderFns } from "./WarehouseArticles.vue?vue&type=template&id=36e60e16"
import script from "./WarehouseArticles.vue?vue&type=script&lang=js"
export * from "./WarehouseArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports